import { useCallback } from 'react';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import { StickyNavApiEntry } from '@interfaces/models/sticky-nav';
import { isUniverseEntryPoint } from '@helpers/utils/sticky-nav/sticky-nav-entry-point-helpers';

interface UseStickyNavNavigationParams {
  currentUniverse: number;
}

const useStickyNavNavigation = ({ currentUniverse }: UseStickyNavNavigationParams) => {
  const { sendAnalyticEvent } = useAnalyticEvents('navigation');

  const buildLinkHref = useCallback((entryPoint: StickyNavApiEntry): string => {
    return entryPoint.destination?.universalLink || '#';
  }, []);

  const handleEntryPointClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>, entryPoint: StickyNavApiEntry) => {
      const isUniverse = isUniverseEntryPoint(entryPoint);

      sendAnalyticEvent('click_sticky_navigation', {
        label: 'sticky_navigation',
        property: isUniverse ? '' : entryPoint.destination?.categoryId || '',
        value: currentUniverse,
      });
    },
    [currentUniverse, sendAnalyticEvent],
  );

  return {
    handleEntryPointClick,
    buildLinkHref,
  };
};

export default useStickyNavNavigation;
